import React from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';

import logo from '../images/IRWIN-Logo-FullColor-RGB.png';

const Login = props => {
  const attemptLogin = () => {
    window.authManager.login();
  };

  const splashStyle = {
    backgroundSize: 'cover, cover',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  };

  return (
    <div className="login-container" style={splashStyle}>
      <Dialog modal={true} open={true} contentStyle={{ width: '300px' }}>
        <div>
          <div style={{ textAlign: 'center' }}>
            <img src={logo} width="177px" alt="IRWIN" />
            <p>Please login to use Observer.</p>
          </div>
          <RaisedButton
            label="Login"
            primary={true}
            fullWidth={true}
            onClick={attemptLogin}
          />
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  appConfig: state.config
});

export default connect(
  mapStateToProps,
  null
)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js